import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

import CreateIcon from "@material-ui/icons/Create";
import { Code , GroupWork} from "@material-ui/icons";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          <h2 className={classes.body1}>Hello{"'"}s I am Rachit</h2>
          <h5 className={classes.root}>
            Hello I'm Rachit, a senior software engineer. I enjoy creating things that 
            live on the internet or intranet,
            whether that be websites, applications, or anything in between. My
            goal is to always build products that provide pixel-perfect,
            performant experiences.
            I'm quietly confident, naturally
            curious, and perpetually working on improving and upskilling always.

          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Designer"
              description="I value simple content structure, clean design patterns, and thoughtful interactions."
              icon={CreateIcon}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Full Stack Developer"
              description="I like to code things from scratch, and enjoy bringing ideas to life in the browser."
              icon={Code}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Mentor"
              description="I genuinely care about people, and love helping fellow students work on their craft."
              icon={GroupWork}
              iconColor="info"
              vertical
            />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
